import { Button, FormControl, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import { useEffect, useState } from "react";
import ApiServices from "../services/ApiServices";

function RegisterUser(props) {


    const [showPassword, setShowPassword] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const editMode = props.editMode;

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    }

    const handleFirstnameChange = (event) => {
        setFirstName(event.target.value);
    }

    const handleLastnameChange = (event) => {
        setLastName(event.target.value);
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setEmailError('');
        if (validateEmail(email)) {
            const signup = { 'firstName': firstName, 'lastName': lastName, 'email': email, 'password': password };
            if (editMode) {
                ApiServices.updateUser(props.editRowId, signup)
                    .then(response => {
                        if (response.status === 200) {
                            props.submittedSuccessfully(true, "User updated successfully.");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        props.submittedSuccessfully(false, error.response?.data ?? error.message);
                    })

            } else {
                ApiServices.registerUser(signup)
                    .then(response => {
                        if (response.status === 200) {
                            props.submittedSuccessfully(true, "User registered successfully.");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        props.submittedSuccessfully(false, error.response?.data ?? error.message);
                    });
            }
        } else {
            setEmailError("Invalid email address.")
        }

    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    };

    const handleMouseDownPassword = () => {
        setShowPassword(!showPassword)
    };

    const validateEmail = (email) => {
        let result = true;

        if (email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            result = re.test(String(email).toLowerCase());
        }

        return result;
    }

    useEffect(() => {
        if (editMode) {
            ApiServices.getUser(props.editRowId)
                .then(response => {
                    if (response.status === 200) {
                        setFirstName(response.data.firstName);
                        setLastName(response.data.lastName);
                        setEmail(response.data.email);
                    }
                })
                .catch(error => {
                    props.submittedSuccessfully(false, error.response?.data ?? error.message);
                });
        }
    }, [editMode, props.editRowId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <form onSubmit={handleFormSubmit} sx={{ mt: 2, "& .MuiTextField-root": { width: "100%" } }} autoComplete="off">
            <FormControl sx={{ m: 1 }}>
                <TextField value={firstName} onChange={handleFirstnameChange} required name="first" label="First name" variant="standard" />
            </FormControl>
            <FormControl sx={{ m: 1 }}>
                <TextField style={{ width: '250px' }} value={lastName} onChange={handleLastnameChange} required name="last" label="Last name" variant="standard" />
            </FormControl>
            <br></br>
            <FormControl sx={{ m: 1 }}>
                <TextField required
                    value={email}
                    onChange={handleEmailChange}
                    name="email" label="Email" variant="standard"
                    error={emailError ? true : false}
                    helperText={emailError}
                    disabled={editMode} />
            </FormControl>
            <FormControl sx={{ m: 1 }}>
                <TextField
                    label='Password'
                    type={showPassword ? "text" : "password"}
                    variant="standard"
                    value={password}
                    onChange={handlePasswordChange}
                    required
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </FormControl>
            <br></br>
            <FormControl style={{ margin: 5, float: 'right' }}>
                <Button variant="contained" color="primary" type='submit'>Submit</Button>
            </FormControl>
        </form>
    );
}

export default RegisterUser;